import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListDiscountsComponent } from './components/list-discounts/list-discounts.component';
import { AdminEmployeeDiscountsComponent } from './components/admin-employee-discounts/admin-employee-discounts.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
  {path:'list-discounts',component:ListDiscountsComponent,canActivate:[AuthGuard],data:{role:'Administrador'}},
  {path:'',component:AdminEmployeeDiscountsComponent},
  {path:'admin-employee-discounts',component:AdminEmployeeDiscountsComponent,canActivate:[AuthGuard],data:{role:'Administrador'}}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EmployeeDiscountsRoutingModule { }
